import {
  GET_LIST,
  DETAIL,
  CREATE,
  UPDATE,
  DELETE,
  GET_POINTING_USERS,
  GET_STATUS_USER,
  GET_LIST_GROUP,
} from "../../api/location/location";
import querystring from "query-string";

const state = {
  list: [],
  detail: {},
  qr: "",
  list_group: [],
  pointing_users: [],
  status_user: {
    total_active: 0,
    total_away: 0,
    total_wfo: 0,
    total_wfh: 0,
  },
  columns: [
    {
      label: "Name",
      field: "location_name",
    },
    {
      label: "QR Code",
      field: "qrcode",
    },
    {
      label: "Created At",
      field: "created_at",
    },
    {
      label: "Updated At",
      field: "updated_at",
    },
    {
      label: "Action",
      field: "action",
    },
  ],
};
const mutations = {
  SET_QR_CODE: (state, payload) => {
    state.qr = payload;
  },
  SET_LIST: (state, payload) => {
    state.list = payload;
  },
  SET_DETAIL: (state, payload) => {
    payload["geolocation"] = JSON.parse(payload["raw_geolocation"]);
    state.detail = payload;
  },
  SET_ALL_POINTING_USER: (state, payload) => {
    state.pointing_users = payload;
  },
  SET_ALL_STATUS_USER: (state, payload) => {
    state.status_user = payload.status;
  },
  SET_LIST_GROUP: (state, payload) => {
    state.list_group = payload;
  },
};
const actions = {
  GET_LIST: async ({ commit }, params) => {
    params = querystring.stringify(params);
    const resp = await GET_LIST(params);
    const data = resp.data.data;
    commit("SET_LIST", data);
  },
  GET_POINTING_USERS: async ({ commit }, params) => {
    params = querystring.stringify(params);
    const resp = await GET_POINTING_USERS(params);
    const data = resp.data.data;
    commit("SET_ALL_POINTING_USER", data);
  },
  GET_STATUS_USER: async ({ commit }, params) => {
    params = querystring.stringify(params);
    const resp = await GET_STATUS_USER(params);
    const data = resp.data.data;
    commit("SET_ALL_STATUS_USER", data);
  },
  DETAIL: async ({ commit }, args) => {
    const resp = await DETAIL(args.id);
    const data = resp.data.data;
    commit("SET_DETAIL", data);
  },
  CREATE: async ({ commit }, args) => {
    console.log("qweqw", args.payload);
    await CREATE(args.payload);
  },
  UPDATE: async ({ commit }, args) => {
    await UPDATE(args.id, args.payload);
  },
  DELETE: async ({ commit }, args) => {
    await DELETE(args.id);
  },
  GET_LIST_GROUP: async ({ commit }, params) => {
    params = querystring.stringify(params);
    const resp = await GET_LIST_GROUP(params);
    const data = resp.data.data;
    commit("SET_LIST_GROUP", data);
  },
};
const getters = {
  list: (state) => state.list,
  list_group: (state) => state.list_group,
  detail: (state) => state.detail,
  columns: (state) => state.columns,
  qr: (state) => state.qr,
  status_user: (state) => state.status_user,
  pointing_users: (state) => state.pointing_users,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
